import {Icon, Show, Spinner, Text} from 'platform/foundation';
import styled, {css} from 'styled-components';

import {suffixTestId, TestIdProps} from 'shared/web';

interface SavedFiltersDropdownTriggerProps extends TestIdProps {
  label: string;
  isPlaceholder: boolean;
  isOpen: boolean;
  isLoading: boolean;
}

export function SavedFiltersDropdownTrigger(props: SavedFiltersDropdownTriggerProps) {
  const {label, isPlaceholder, isOpen, isLoading} = props;

  return (
    <TriggerButton type="button" $isOpen={isOpen} data-testid={suffixTestId('trigger', props)}>
      <Show when={isLoading}>
        <Spinner
          variant="overlay"
          size="small"
          data-testid={suffixTestId('triggerSpinner', props)}
        />
      </Show>
      <TriggerLabel size="small" noWrap color={isPlaceholder ? 'tertiary' : undefined}>
        {label}
      </TriggerLabel>
      <Icon
        value={isOpen ? 'navigation/expand_less' : 'navigation/expand_more'}
        size={4}
        color="text.primary"
      />
    </TriggerButton>
  );
}

const TriggerLabel = styled(Text)`
  flex: 1 1 auto;
  min-width: 0;
`;

const TriggerButton = styled.button<{$isOpen: boolean}>`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${({theme}) => theme.getSize(2)};
  width: 100%;
  min-height: ${({theme}) => theme.getSize(8)};
  padding: 5px 8px;
  box-sizing: border-box;
  border: 1px solid ${({theme}) => theme.colors.palettes.neutral[70][100]};
  border-radius: ${({theme}) => theme.radii.small};
  background-color: ${({theme}) => theme.colors.palettes.white[10][100]};
  color: ${({theme}) => theme.colors.text.primary};
  font: inherit;
  cursor: pointer;
  text-align: left;

  ${({theme, $isOpen}) =>
    $isOpen &&
    css`
      border-color: ${theme.colors.severity.informational};
      box-shadow: ${theme.shadows.active};
    `}

  &:hover:not(:disabled) {
    border-color: ${({theme}) => theme.colors.severity.informational};
    background-color: ${({theme}) => theme.colors.palettes.white[10][100]};
  }

  &:focus-visible {
    border-color: ${({theme}) => theme.colors.severity.informational};
    box-shadow: ${({theme}) => theme.shadows.active};
    outline: none;
  }

  &:disabled {
    border-color: ${({theme}) => theme.colors.palettes.neutral[70][40]};
    background-color: ${({theme}) => theme.colors.palettes.white[10][40]};
    cursor: not-allowed;
    box-shadow: none;
  }
`;
